import { useState, useEffect } from 'react';
import QA from '../Forms/QA.json';

const ExamsQSelection = () => {
    const totalScoreThreshold = 100; // The desired total score threshold
    const [selectedQuestions, setSelectedQuestions] = useState([]); // Array to store the selected questions
    const [selectedQuestionIDs, setSelectedQuestionIDs] = useState([]); // Array to store the IDs of selected questions

    useEffect(() => {
        let totalScore = 0;
        const updatedSelectedQuestions = [];
        const updatedSelectedQuestionIDs = [];

        while (totalScore < totalScoreThreshold) {
            // Generate a random number to decide which table to select from
            const randomTable = Math.floor(Math.random() * 2); // 0 for 'vasikes', 1 for 'eidikes'

            // Select the table based on the random number
            const table = (randomTable === 0) ? 'vasikes' : 'eidikes';

            // Get the questions data from the selected table
            const tableData = QA.find(item => item.name === table)?.data;

            if (!tableData) {
                console.error(`Table data for '${table}' not found in QA.json`);
                continue;
            }

            // Generate a random index within the range of questions in the selected table
            const randomIndex = Math.floor(Math.random() * tableData.length);

            // Retrieve the question data at the random index
            const questionData = tableData[randomIndex];

            // Check if the question ID is already selected
            if (selectedQuestionIDs.includes(questionData.erid)) {
                // Skip this question and continue to the next iteration
                continue;
            }

            // Calculate the updated total score after adding the question's score
            const questionScore = parseInt(questionData.Vathmos);
            const updatedScore = totalScore + questionScore;

            // Check if adding the question would cause the total score to exceed the threshold
            if (updatedScore > totalScoreThreshold) {
                // If adding the question would exceed the threshold, skip this question
                continue;
            }

           
            updatedSelectedQuestions.push({ ...questionData, table });
            updatedSelectedQuestionIDs.push(questionData.erid);
            totalScore = updatedScore;
        }

        // Update the state with the selected questions and their IDs
        setSelectedQuestions(updatedSelectedQuestions);
        setSelectedQuestionIDs(updatedSelectedQuestionIDs);

    }, []); 
   

    
    return (
       selectedQuestions
    );
};

export default ExamsQSelection;
